/**
 * Zeniora Mobile Category Tabs Interaction
 * Handles top tab switching, sidebar switching, scroll resetting,
 * and Shopify Section Theme Editor lifecycle events.
 */

(function () {
  'use strict';

  function initZenioraMobileCategory() {
    const containers = document.querySelectorAll('.zeniora-mobile-category');
    if (!containers.length) return;

    containers.forEach((container) => {
      // 避免重复初始化
      if (container.dataset.initialized === 'true') return;
      container.dataset.initialized = 'true';

      const tabItems = container.querySelectorAll('.zeniora-mobile-category__tab-item');
      const tabPanels = container.querySelectorAll('.zeniora-mobile-category__tab-panel');

      // 1. 一级 Tab 切换逻辑
      tabItems.forEach((tab) => {
        tab.addEventListener('click', () => {
          const index = tab.getAttribute('data-tab-index');

          // 激活 Tab 按钮
          tabItems.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');

          // 激活对应的一级面板
          tabPanels.forEach((panel) => {
            const panelIndex = panel.getAttribute('data-tab-panel');
            if (panelIndex === index) {
              panel.classList.add('active');
              // 自动切换一级 Tab 后，重置该面板内二级/三级菜单的状态
              resetPanelState(panel);
            } else {
              panel.classList.remove('active');
            }
          });

          // 让选中的 Tab 自动滚动到视图居中位置
          tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
      });

      // 2. 二级 Sidebar 切换逻辑 (针对 3 级深度模式)
      tabPanels.forEach((panel) => {
        if (panel.classList.contains('has-sidebar')) {
          const sidebarItems = panel.querySelectorAll('.zeniora-mobile-category__sidebar-item');
          const gridPanels = panel.querySelectorAll('.zeniora-mobile-category__grid-panel');
          const gridContainer = panel.querySelector('.zeniora-mobile-category__grid-container');

          sidebarItems.forEach((sidebar) => {
            sidebar.addEventListener('click', () => {
              const index = sidebar.getAttribute('data-sidebar-index');

              // 激活 Sidebar 按钮
              sidebarItems.forEach(s => s.classList.remove('active'));
              sidebar.classList.add('active');

              // 激活对应的三级网格面板
              gridPanels.forEach((gridPanel) => {
                const gridIndex = gridPanel.getAttribute('data-grid-panel');
                if (gridIndex === index) {
                  gridPanel.classList.add('active');
                } else {
                  gridPanel.classList.remove('active');
                }
              });

              // 每次切换二级，把右侧 Grid 滚动条拉回最顶部
              if (gridContainer) {
                gridContainer.scrollTop = 0;
              }

              // 使选中的二级按钮滚动到可见区域
              sidebar.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            });
          });
        }
      });
    });
  }

  // 辅助函数：重置面板状态 (使默认高亮显示每一级 Tab 的第一项)
  function resetPanelState(panel) {
    // 只有 3 级深度（有 sidebar）才需要重置
    if (panel.classList.contains('has-sidebar')) {
      const sidebarItems = panel.querySelectorAll('.zeniora-mobile-category__sidebar-item');
      const gridPanels = panel.querySelectorAll('.zeniora-mobile-category__grid-panel');
      const gridContainer = panel.querySelector('.zeniora-mobile-category__grid-container');

      // 重置二级高亮到第一个
      sidebarItems.forEach((s, i) => {
        if (i === 0) {
          s.classList.add('active');
        } else {
          s.classList.remove('active');
        }
      });

      // 重置三级网格高亮到第一个
      gridPanels.forEach((gp, i) => {
        if (i === 0) {
          gp.classList.add('active');
        } else {
          gp.classList.remove('active');
        }
      });

      // 重置右侧滚动条
      if (gridContainer) {
        gridContainer.scrollTop = 0;
      }
    } else {
      // 2 级深度，直接把右侧的滚动条拉回最顶部
      const gridContainer = panel.querySelector('.zeniora-mobile-category__grid-container');
      if (gridContainer) {
        gridContainer.scrollTop = 0;
      }
    }
  }

  // 初始化绑定
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZenioraMobileCategory);
  } else {
    initZenioraMobileCategory();
  }

  // 支持 Shopify 主题编辑器的动态 Section 加载更新生命周期
  document.addEventListener('shopify:section:load', function (event) {
    // 如果是我们的 Section，或者 Section 内部包含了我们的分类组件，重新初始化
    if (event.target.querySelector('.zeniora-mobile-category')) {
      initZenioraMobileCategory();
    }
  });

})();
